/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
 import Grid from "@mui/material/Grid";
// import Tooltip from "@mui/material/Tooltip";
// import Icon from "@mui/material/Icon";
// import { useEffect, useState } from "react";
// Material Dashboard 2 PRO React components
 import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
 import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
 import DashboardNavbar from "examples/Navbars/DashboardNavbar";
 import Footer from "examples/Footer";
// import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
// import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
 import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
// import BookingCard from "examples/Cards/BookingCard";

// Anaytics dashboard components
// import SalesByCountry from "layouts/dashboards/analytics/components/SalesByCountry";

// Data
// import reportsBarChartData from "layouts/dashboards/analytics/data/reportsBarChartData";
// import reportsLineChartData from "layouts/dashboards/analytics/data/reportsLineChartData";

// Images
// import booking1 from "assets/images/products/product-1-min.jpg";
// import booking2 from "assets/images/products/product-2-min.jpg";
// import booking3 from "assets/images/products/product-3-min.jpg";
// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableRow from '@mui/material/TableRow';
// import Paper from '@mui/material/Paper';
// import * as service from '../../../services/service';

function Analytics() {
  // const [countData, setCountData] = useState([]);  
  // const [stateCountData, setStateCountData] = useState([]);
  // const [districtCountData, setDistrictCountData] = useState([]);
  // const [reconcileData, setReconcileData] = useState([]);
  // const [couponData, setCouponData] = useState([]);
  // const [bankCollectionData, setBankCollectionData] = useState([]);
  // const [cashCollectionData, setCashCollectionData] = useState([]);
  // const [onlineCollectionData, setOnlineCollectionData] = useState([]);

  // const getTotalCounts = () => {
  //   // setLoading(true);    
  //   fetch(
  //     service.GET_TOTAL_COUNT,
  //     {
  //       method: 'POST',
  //       headers: {
  //         'Accept': 'application/json',
  //         'Content-Type': 'application/json'
  //       }
  //     })
  //     .then(res => res.json())
  //     .then(result => {
  //       setCountData(result);
  //     })
  //     .catch(err => {
  //       if (err) {
  //         // setDataError(err);
  //       };
  //     });
  //   // setLoading(false);
  // };

  // const getStateWiseCounts = () => {
  //   // setLoading(true);    
  //   fetch(
  //     service.GET_STATE_WISE_COUNT,
  //     {
  //       method: 'POST',
  //       headers: {
  //         'Accept': 'application/json',
  //         'Content-Type': 'application/json'
  //       }
  //     })
  //     .then(res => res.json())
  //     .then(result => {
  //       setStateCountData(result);        
  //     })
  //     .catch(err => {
  //       if (err) {
  //         // setDataError(err);
  //       };
  //     });
  //   // setLoading(false);
  // };

  // const getMaharashtraDistrictWiseCounts = () => {
  //   // setLoading(true);    
  //   fetch(
  //     service.GET_MAHARASHTRA_DISTRICT_WISE_COUNT,
  //     {
  //       method: 'POST',
  //       headers: {
  //         'Accept': 'application/json',
  //         'Content-Type': 'application/json'
  //       }
  //     })
  //     .then(res => res.json())
  //     .then(result => {
  //       setDistrictCountData(result);               
  //     })
  //     .catch(err => {
  //       if (err) {
  //         // setDataError(err);
  //       };
  //     });
  //   // setLoading(false);
  // };

  // const getReconciledData = () => {
  //   // setLoading(true);    
  //   fetch(
  //     service.GET_RECONCILE_DASHBOARD,
  //     {
  //       method: 'POST',
  //       headers: {
  //         'Accept': 'application/json',
  //         'Content-Type': 'application/json'
  //       }
  //     })
  //     .then(res => res.json())
  //     .then(result => {
  //       setReconcileData(result);          
  //     })
  //     .catch(err => {
  //       if (err) {
  //         // setDataError(err);
  //       };
  //     });
  //   // setLoading(false);
  // };

  // const getCouponData = () => {
  //   // setLoading(true);    
  //   fetch(
  //     service.GET_COUPONS_DASHBOARD,
  //     {
  //       method: 'POST',
  //       headers: {
  //         'Accept': 'application/json',
  //         'Content-Type': 'application/json'
  //       }
  //     })
  //     .then(res => res.json())
  //     .then(result => {        
  //       setCouponData(result);          
  //     })
  //     .catch(err => {
  //       if (err) {
  //         // setDataError(err);
  //       };
  //     });
  //   // setLoading(false);
  // };

  // const getBankCollectionCounts = () => {    
  //   fetch(
  //     service.GET_BANK_COLLECTION_SUMMARY,
  //     {
  //         method: 'POST',
  //         headers: {
  //             'Accept': 'application/json',
  //             'Content-Type': 'application/json'
  //         },
  //         body: JSON.stringify({
  //             CountryId: 1,
  //             StateId: 0,
  //             DistrictId: 0,
  //             FromDate: null,
  //             ToDate: null
  //         })
  //     })
  //     .then(res => res.json())
  //     .then(result => {
  //       const newList = result.filter(el => el.state === 'Total'); 
  //       const array = [newList[0].totalAmount, newList[0].totalCount]             
  //       setBankCollectionData(array);                           
  //     })
  //     .catch(err => {
  //       if (err) {
  //         // setDataError(err);
  //       };
  //     });    
  // };

  // const getCashCollectionCounts = () => {    
  //   fetch(
  //     service.GET_CASH_COLLECTION_SUMMARY,
  //           {
  //               method: 'POST',
  //               headers: {
  //                   'Accept': 'application/json',
  //                   'Content-Type': 'application/json'
  //               },
  //               body: JSON.stringify({
  //                   CountryId: 1,
  //                   StateId: 0,
  //                   DistrictId: 0,
  //                   FromDate: null,
  //                   ToDate: null
  //               })
  //           })
  //     .then(res => res.json())
  //     .then(result => {
  //       const newList = result.filter(el => el.state === 'Total');     
  //       const array = [newList[0].totalAmount, newList[0].totalCount]         
  //       setCashCollectionData(array);             
  //     })
  //     .catch(err => {
  //       if (err) {
  //         // setDataError(err);
  //       };
  //     });    
  // };

  // const getOnlineCollectionCounts = () => {    
  //   fetch(
  //     service.GET_ONLINE_COLLECTION_SUMMARY,
  //     {
  //         method: 'POST',
  //         headers: {
  //             'Accept': 'application/json',
  //             'Content-Type': 'application/json'
  //         },
  //         body: JSON.stringify({
  //             CountryId: 1,
  //             StateId: 0,
  //             DistrictId: 0,
  //             FromDate: null,
  //             ToDate: null
  //         })
  //     })
  //     .then(res => res.json())
  //     .then(result => {        
  //       const newList = result.filter(el => el.state === 'Total'); 
  //       const array = [newList[0].totalAmount, newList[0].totalCount]      
  //       setOnlineCollectionData(array);               
  //     })
  //     .catch(err => {
  //       if (err) {
  //         // setDataError(err);
  //       };
  //     });    
  // };

  // useEffect(() => {
  //   getTotalCounts();
  //   getStateWiseCounts();
  //   getMaharashtraDistrictWiseCounts();
  //   getReconciledData();
  //   getCouponData();
  //   getBankCollectionCounts();
  //   getCashCollectionCounts();
  //   getOnlineCollectionCounts();
  // }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <MDBox mt={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="dark"
                  icon="people"
                  title="Demand"
                  count={0}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  icon="boy"
                  title="Receipt"
                  count={0}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="success"
                  icon="face"
                  title="Distribution"
                  count={0}
                />
              </MDBox>
            </Grid><Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="success"
                  icon="face"
                  title="Balance"
                  count={0}
                />
              </MDBox>
            </Grid>           
          </Grid>
        </MDBox> 
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Analytics;
